import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, hashHistory, IndexRedirect} from 'react-router';
import {createStore, applyMiddleware, compose} from 'redux';
import {Provider} from 'react-redux';
import {responsiveStoreEnhancer} from 'redux-responsive'
import reducer from './reducer';
import App from './containers/App';
import dataService from './data-service';

let store = createStore(reducer, compose(
  responsiveStoreEnhancer,
  applyMiddleware(dataService),
  window.devToolsExtension ? window.devToolsExtension() : f => f
));

ReactDOM.render(
  <Provider store={store}>
    <Router history={hashHistory}>
      <Route path="/" component={App}>
        <IndexRedirect to='/probability/1000000-50/2016/all_boroughs/all_neighborhoods' query={{ explainer: true }} />
        <Route path=":mode/:active_var/:year/:borough_filter/:neighborhood(/:hex)" component={App}></Route>
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root')
)




/** WEBPACK FOOTER **
 ** ./src/index.js
 **/